export async function MountEventList(props: any, el: Element) {
	const list = await import('./EventList');
	list.MountEventList(props, el);
}
